import React, { Component } from "react";
import Popup from "reactjs-popup";
import axios from 'axios';
import { Grid, GridColumn, GridNoRecords, GridToolbar } from '@progress/kendo-react-grid';
import { process } from '@progress/kendo-data-query';
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import { parseDate } from '@telerik/kendo-intl';

class EntityPopup extends Component {

    constructor(props) {
        super(props);


        this.state = {
            updates: [],
            dataState: {},
            EntityCode: ''
        }
    }

    componentDidMount() {

    }

    getDemographics = (cb) => {
        this.setState({ refreshText: 'Loading...' })
        var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
        var demographics = [];



        axios(`api/demographicsEntity`, {
            method: 'GET',
            params: {
                company: this.props.user.company,
                entity: this.props.entity,
            },
            headers: headers,
        })
            .then(response => {
                console.log(response)
                demographics = response.data.data[0]
                var d2 = []
                for (const p in demographics) {
                    d2.push({ field: p, label: p.replace(/([A-Z])/g, ' $1').trim(), value: demographics[p] })
                }
                var result = process(d2, this.state.dataState)
                console.log(result)
                this.setState({ demographics: d2, result: result, refreshText: '' })

            })
            .catch(err => {
                console.error(err);
            })
    }

    updateDemographics(cb) {
        if (this.validate()) {
            this.setState({ refreshText: 'Loading...' })
            var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
            var demographicsEntry = [];

            if (this.props.create){//copy demographics, add date and RunDate 
                demographicsEntry = [...this.state.demographics];
                demographicsEntry.push({field: 'RunDate', value: new Date()})
                demographicsEntry.push({field: 'date', value: new Date()})
            }

            var payload = {
                company: this.props.user.company,
                entity: this.props.entity || this.state.EntityCode,
                updates: this.props.create ? demographicsEntry : this.state.updates,
            };

            axios.post('api/demographicsEntity' + (this.props.create ? 'New' : ''), payload, { headers }).then(response => {
                console.log(response)
                cb()

            })
                .catch(err => {
                    console.error(err);
                })
        }
    }

    delete(cb) {
        if (window.confirm('Are you sure you want to delete ' + this.props.entity + '? This cannot be undone')) {
            this.setState({ refreshText: 'Loading...' })
            var headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

            var payload = {
                company: this.props.user.company,
                entity: this.props.entity
            };

            axios.post('api/demographicsEntityDelete', payload, { headers }).then(response => {
                console.log(response)
                cb(true)

            })
                .catch(err => {
                    console.error(err);
                })
        }
        else { cb(false) }
    }

    validate() {
        for (var u of (this.props.create ? this.state.demographics : this.state.updates)) {
            if (this.props.create && u.field === 'EntityCode') {
                if (!u.value) {
                    alert('EntityCode is required');
                    return false
                }
            }
            if (u.field.toLowerCase().includes('date')) {
                if (u.value && !parseDate(u.value)) {
                    alert('Dates must be in \'mm/dd/yyyy\' format')
                    return false
                }
            }
            if (u.field === 'EntityType') {
                if (!u.value || (u.value !== 'P' && u.value !== 'G')) {
                    alert('Entity Type must be either \'P\' or \'G\'')
                    return false
                }
            }
        }
        return true
    }

    clearState = () => {
        this.setState({
            updates: [],
            dataState: {},
            result: null,
            demographics: null,
            EntityCode: ''
        });
    }

    onValueChange(field, value) {
        var updates = this.state.updates
        var demographics = this.state.demographics
        if (field === 'EntityCode') {
            this.setState({ EntityCode: value })
        }
        const i = updates.findIndex(e => e.field === field);
        const i2 = demographics.findIndex(e => e.field === field);
        if (i > -1) {
            updates[i].value = value
        }
        else {
            updates.push({ field: field, value: value })
        }
        demographics[i2].value = value
        var result = process(demographics, this.state.dataState)
        this.setState({ updates: updates, demographics: demographics, result: result })
    }

    formatDate(date) {
        var d;

        if (parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX")) { d = parseDate(date, "yyyy-MM-ddTHH:mm:ss.SSSXXX") }
        else { d = parseDate(date, "MM/dd/yyyy HH:mm:ss") }

        const day = String(d.getUTCDate()).padStart(2, '0');
        const month = String(d.getUTCMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const year = d.getUTCFullYear();

        return `${month}/${day}/${year}`;

    }

    isDisabled(field) {
        switch (field) {
            case 'RunDate':
                return true
            case 'date':
                return true
            case 'Date':
                return true
            case 'EntityCode':
                if (this.props.create) { return false } else { return true }
            default:
                return false
        }
    }

    isLongerField(field) {
        switch (field) {
            case 'Name1':
                return true
            case 'Name2':
                return true
            case 'Name3':
                return true
            case 'Footnote1':
                return true
            case 'Footnote2':
                return true
            case 'Footnote3':
                return true
            case 'BillingNote':
                return true
            case 'BillingNote2':
                return true
            default:
                return false
        }
    }


    createCell = (cell) => {
        var isDisabled = this.isDisabled(cell.dataItem.field);
        var spanTip = <span></span>
        if (cell.dataItem.field.toLowerCase().includes('date')) {
            if (cell.dataItem.value && (parseDate(cell.dataItem.value, "yyyy-MM-ddTHH:mm:ss.SSSXXX") || parseDate(cell.dataItem.value, "MM/dd/yyyy HH:mm:ss"))) { cell.dataItem.value = this.formatDate(cell.dataItem.value).toString() };
            spanTip =  <span style={{fontSize:'85%', fontStyle:'italic', opacity:'0.8'}}>{'format: \'mm/dd/yyyy\''}</span>
        }
        else if (cell.dataItem.field === 'EntityType'){
            spanTip =  <span style={{fontSize:'85%', fontStyle:'italic', opacity:'0.8'}}>{'Enter P for portfolio, or G for group'}</span>
        }
        else if (cell.dataItem.field === 'BillingMethod'){
            spanTip =  <span style={{fontSize:'85%', fontStyle:'italic', opacity:'0.8'}}>{'Enter t for Tiered, or f for Flat Fee'}</span>
        }
        else if (cell.dataItem.field === 'PaymentPeriod'){
            spanTip =  <span style={{fontSize:'85%', fontStyle:'italic', opacity:'0.8'}}>{'Enter 1 for Annual, 2 for Semi-Annual, etc…'}</span>
        }
        else if (cell.dataItem.field === 'MinimumFee'){
            spanTip =  <span style={{fontSize:'85%', fontStyle:'italic', opacity:'0.8'}}>{'Enter 0 if no minimum fee'}</span>
        }

        return (
            <td>
                <Input defaultValue={cell.dataItem.value} style={{width: this.isLongerField(cell.dataItem.field) ? '100%' : '50%'}} key={cell.dataItem.field + 'Input'} disabled={isDisabled} value={cell.dataItem.value} onChange={(e) => { this.onValueChange(cell.dataItem.field, e.target.value) }} /> {spanTip}
            </td>
        );
    }

    changeDataState = (e) => {
        var data = { ...e.dataState }
        if (data.filter != null && data.filter.filters != null) {
            data.filter.filters.forEach(item => {
            })
            // data.filter.filters = data.filter.filters.filter(item => item.value !== '(All)');
        }
        var newData = process(this.state.demographics, data);
        this.setState({ dataState: data, result: newData });
    }

    render() {
        return (
            <Popup closeOnDocumentClick={false} trigger={this.props.button} onOpen={() => { this.setState({ EntityCode: this.props.entity }); this.getDemographics() }} onClose={() => { this.clearState(); this.props.refresh(); }} overlayStyle={{ zIndex: 5 }} modal>
                {close => (
                    <div className="modal">
                        <Button className="close" icon="close" onClick={(e) => { close(); }} />
                        <div className="header" align="left">
                            {this.props.create ? 'Create New' : 'Edit - ' + this.props.entity}
                        </div>
                        <div className="content">
                            <Grid data={this.state.result}
                                style={{height:'65vh'}}
                                onDataStateChange={this.changeDataState}
                                {...this.state.dataState}>
                                <GridNoRecords>
                                    {this.state.refreshText && ''}
                                    {!this.state.refreshText && 'No records available'}
                                </GridNoRecords>
                                <GridToolbar>
                                    {!this.props.create && <Button icon='refresh' title='Refresh' onClick={(e) => this.getDemographics()}>{this.state.refreshText}</Button>}
                                    {!this.props.create && <Button icon="delete" title='Delete' onClick={() => { this.delete((cb) => { if (cb) { close() } }) }}>{'Delete ' + this.props.entity}</Button>}
                                </GridToolbar>
                                <GridColumn field="label" key='labelCol' title="Label" width="165px" filterable={true} />
                                <GridColumn field="value" key='valueCol' title="Value" width="250px" filterable={true} cell={this.createCell} />
                            </Grid>
                        </div>
                        <div className="actions">
                            <Button
                                className="button"
                                onClick={() => { close(); }}>
                                Cancel
                            </Button>
                            <Button
                                className="upload"
                                onClick={() => { this.updateDemographics(() => { close(); }) }}>
                                {this.props.create ? 'Save' : 'Update'}
                            </Button>
                        </div>
                    </div>
                )}
            </Popup>

        );
    };
}

export default EntityPopup;